import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "./Footer";
import { useIsMobile } from "@/hooks/use-mobile";
import { useModal } from "@/context/ModalContext";
import MobileWarningModal from "@/pages/collection/info/MobileWarningModal";
import CookiesBanner from "@/components/cookieBanner/CookiesBanner";

const Layout: React.FC = () => {
  const isMobile = useIsMobile();
  const { showModal, hideModal } = useModal();

  useEffect(() => {
    if (isMobile && !window.location.href.includes("/infos")) {
      const dontShowAgain = window.localStorage.getItem(
        "mobileBannerDontShowAgain"
      );
      if (dontShowAgain !== "true") {
        showModal(<MobileWarningModal />);
      }
      return;
    }
    hideModal();
  }, [isMobile, window.location.href]);

  return (
    <div className="flex h-screen w-full flex-col">
      <Header />
      <div className="relative sm:static overflow-auto w-full h-full flex flex-col">
        <main className="flex flex-1 flex-col gap-4">
          <Outlet />
        </main>
        <div className="z-20 bg-white ">
          <Footer />
        </div>
      </div>
      <CookiesBanner />
    </div>
  );
};

export default Layout;
